import api from '../../auth/apiClient';
import { SaktiSyncEntitiesResponse, SaktiSyncJob } from '../../sakti/types';

const BASE_PATH = '/admin/master-sync';

/**
 * Insight master-data sync (Odoo → insight DB). The backend runs the matching
 * `scripts/sync_*.py` file per entity and returns the same job shapes as the Sakti
 * config sync, so `useSaktiSync` + `SaktiSyncPanel` render it unchanged.
 */
export class MasterSyncApiService {
  static async listSyncEntities(): Promise<SaktiSyncEntitiesResponse> {
    const response = await api.get<SaktiSyncEntitiesResponse>(`${BASE_PATH}/entities`);
    return response.data;
  }

  // `["all"]` runs every entity in dependency order. 409 while a job is running.
  static async startSyncJob(entities: string[]): Promise<SaktiSyncJob> {
    const response = await api.post<SaktiSyncJob>(`${BASE_PATH}/jobs`, { entities });
    return response.data;
  }

  static async getSyncJob(jobId: string): Promise<SaktiSyncJob> {
    const response = await api.get<SaktiSyncJob>(`${BASE_PATH}/jobs/${jobId}`);
    return response.data;
  }
}

export default MasterSyncApiService;
